(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AffordHomeBudgetCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["AffordHomeBudgetCalculator"] = factory();
	else
		root["AffordHomeBudgetCalculator"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition